export default "__VITE_ASSET__CfvCaKkA__"